import { registerCommands, registerSearchProvider } from './registry';
import { uiCommands } from './command-providers/ui-commands';
import { tabCommands } from './command-providers/tab-commands';
import { connectionCommands } from './command-providers/connection-commands';
import { queryCommands } from './command-providers/query-commands';
import { tableCommands } from './command-providers/table-commands';
import { databaseCommands } from './command-providers/database-commands';
import { themeCommands } from './command-providers/theme-commands';
import { metaCommands } from './command-providers/meta-commands';

import { tableSearchProvider } from './search-providers/table-search';
import { viewSearchProvider } from './search-providers/view-search';
import { columnSearchProvider } from './search-providers/column-search';
import { connectionSearchProvider } from './search-providers/connection-search';
import { tunnelSearchProvider } from './search-providers/tunnel-search';
import { tabSearchProvider } from './search-providers/tab-search';
import { savedQuerySearchProvider } from './search-providers/saved-query-search';
import { recentTabSearchProvider } from './search-providers/recent-tab-search';
import { historySearchProvider } from './search-providers/history-search';
import { databaseSearchProvider } from './search-providers/database-search';
import { functionSearchProvider } from './search-providers/function-search';

/**
 * Single bootstrap module. Importing this file registers every provider
 * into the central registry. `main.tsx` imports it once at startup — no
 * component needs to know about individual providers.
 *
 * To add a command: drop a new file into `command-providers/`, export a
 * `Command[]`, and add one line here. Nothing else touches.
 * Same pattern for search providers under `search-providers/`.
 */
let bootstrapped = false;

export function bootstrapCommands(): void {
  if (bootstrapped) return;
  bootstrapped = true;

  // Commands (>)
  registerCommands(uiCommands);
  registerCommands(tabCommands);
  registerCommands(connectionCommands);
  registerCommands(queryCommands);
  registerCommands(tableCommands);
  registerCommands(databaseCommands);
  registerCommands(themeCommands);
  registerCommands(metaCommands);

  // Search items
  registerSearchProvider(tableSearchProvider);
  registerSearchProvider(viewSearchProvider);
  registerSearchProvider(columnSearchProvider);
  registerSearchProvider(connectionSearchProvider);
  registerSearchProvider(tunnelSearchProvider);
  registerSearchProvider(tabSearchProvider);
  registerSearchProvider(savedQuerySearchProvider);
  registerSearchProvider(recentTabSearchProvider);
  registerSearchProvider(historySearchProvider);
  registerSearchProvider(databaseSearchProvider);
  registerSearchProvider(functionSearchProvider);
}

export { listCommands, listSearchProviders, runCommand, runSearchItem } from './registry';
export { buildCommandContext } from './context';
export { parseInput, rankCommands, rankSearchItems } from './scorer';
export { useUsageStore } from './usage-store';
export { useGlobalSchemaStore } from './global-schema-store';
export { useRecentTabStore } from './recent-tab-store';
export type { Command, SearchItem, SearchKind, BarMode, ParsedInput } from './types';
